module.exports = __webpack_public_path__ + "img/李守宇.8688fc2e.png";